var ProductColorChange = /** @class */ (function () {
    function ProductColorChange() {
        this.productPage = document.querySelector('.open-product');
        this.productThumbnailContainer = this.productPage.querySelector('[data-product-thumbnail]');
        if (this.productPage.querySelectorAll('[data-product-film]')) {
            this.productColors = this.productPage.querySelectorAll('[data-film-color]');
            this.addEventListeners();
        }
    }
    ProductColorChange.prototype.addEventListeners = function () {
        var _this = this;
        this.productColors.forEach(function (productColor) {
            productColor.addEventListener('click', _this.toggleColor.bind(_this));
        });
    };
    ProductColorChange.prototype.toggleColor = function (event) {
        var currentColor = event.currentTarget;
        var productColorContainer = currentColor.parentElement;
        this.selectedColor = currentColor.dataset.filmColor;
        this.productColors.forEach(function (productColor) {
            productColor.classList.remove('active');
        });
        currentColor.classList.add('active');
        this.setDomElements();
    };
    ProductColorChange.prototype.setDomElements = function () {
        var _this = this;
        this.productThumbnailContainer.querySelectorAll('img').forEach(function (image) {
            image.classList.add('hidden');
            if (image.dataset.colorId === _this.selectedColor) {
                image.classList.remove('hidden');
                image.classList.add('active');
            }
        });
    };
    return ProductColorChange;
}());
export default ProductColorChange;
